import { useCallback, useEffect, useState, memo } from "react";
import useStore from "../store/store";

const Recommend = memo(({ isPrem }) => {
  const getText = useCallback(
    () =>
      isPrem
        ? "Наиболее оптимальное сочетание очищения организма, расширенной диагностики, комфортных релаксирующих и SPA-процедур."
        : "Повышенная эффективность программы достигается за счёт ранней диагностики и расширенного перечня уходовых процедур. Программа позволяет за короткий срок получить эффект, сопоставимый с тем, который достигается при длительном пребывании на курорте.",
    [isPrem]
  );

  return (
    <div className="prog__type--recommend" title={getText()}>
      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 9C0 8.46957 0.210714 7.96086 0.585787 7.58579C0.960859 7.21071 1.46957 7 2 7H8.32L7.36 2.43C7.34 2.33 7.33 2.22 7.33 2.11C7.33 1.7 7.5 1.32 7.77 1.05L8.83 0L15.41 6.58C15.78 6.95 16 7.45 16 8V18C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H5C4.17 20 3.46 19.5 3.16 18.78L0.139999 11.73C0.0499992 11.5 0 11.26 0 11V9ZM22 20H18V8H22V20Z"
          fill="#00B85D"
        />
      </svg>
      <span>Кивач рекомендует</span>
    </div>
  );
});

// Основной компонент ProgramList
const ProgramList = memo(({ programs }) => {
  const { activeGuest, activeRoom, updateGuest, rooms } = useStore();
  const [selectedProgram, setSelectedProgram] = useState({
    program: null,
    program_type: null,
    program_length: null,
  });

  const { program_length, program, program_type } = rooms[activeRoom].people[activeGuest] || {};

  // Инициализация состояния при монтировании или изменении активного гостя/комнаты
  useEffect(() => {
    if (program && program_length) {
      setSelectedProgram({ program, program_type, program_length });
    } else if (programs?.length > 0) {
      const defaultProgram = programs[0];
      const defaultType = defaultProgram.types[1] || defaultProgram.types[0];
      const defaultLength = defaultType?.lengths[0];

      setSelectedProgram({
        program: { id: defaultProgram.id, name: defaultProgram.name },
        program_type: { id: defaultType.id, name: defaultType.name },
        program_length: defaultLength,
      });
      updateGuest(activeRoom, activeGuest, {
        program: { id: defaultProgram.id, name: defaultProgram.name },
        program_type: { id: defaultType.id, name: defaultType.name },
        program_length: defaultLength,
      });
    }
  }, [activeGuest, activeRoom, program, program_length, program_type, programs, updateGuest]);

  // Переключение программы
  const toggleProgram = useCallback(
    (programId) => {
      const currentProgram = programs.find((prog) => prog.id === programId);
      const defaultType = currentProgram.types[1] || currentProgram.types[0];
      const defaultLength = defaultType?.lengths[0];

      setSelectedProgram((prev) => {
        const isSameProgram = prev.program?.id === programId;
        return {
          program: isSameProgram ? null : { id: programId, name: currentProgram.name },
          program_type: isSameProgram ? null : { id: defaultType.id, name: defaultType.name },
          program_length: isSameProgram ? null : defaultLength,
        };
      });

      updateGuest(activeRoom, activeGuest, {
        program: { id: programId, name: currentProgram.name },
        program_type: { id: defaultType.id, name: defaultType.name },
        program_length: defaultLength,
      });
    },
    [activeGuest, activeRoom, programs, updateGuest]
  );

  // Переключение типа программы
  const toggleType = useCallback(
    (typeId, program_type_name) => {
      const currentProgram = programs.find((prog) => prog.id === selectedProgram.program?.id);
      const selectedType = currentProgram?.types.find((type) => type.id === typeId);
      const defaultLength = selectedType?.lengths[0];

      setSelectedProgram((prev) => ({
        ...prev,
        program_type: { id: typeId, name: program_type_name },
        program_length: defaultLength,
      }));

      updateGuest(activeRoom, activeGuest, {
        program_type: { id: typeId, name: program_type_name },
        program_length: defaultLength,
      });
    },
    [activeGuest, activeRoom, programs, selectedProgram.program?.id, updateGuest]
  );

  // Переключение длительности
  const toggleLength = useCallback(
    (len) => {
      setSelectedProgram((prev) => ({
        ...prev,
        program_length: prev.program_length === len ? null : len,
      }));
      updateGuest(activeRoom, activeGuest, { program_length: len });
    },
    [activeGuest, activeRoom, updateGuest]
  );

  // Рендеринг типов программы
  const renderTypes = useCallback(
    (progId) => {
      const types = programs.find((program) => program.id === progId)?.types || [];
      return (
        <ul>
          {types.map((type) => (
            <li key={type.id}>
              <label>
                <input
                  type="checkbox"
                  onChange={() => toggleType(type.id, type.name)}
                  checked={selectedProgram?.program_type?.id === type.id}
                />
                <div className="prog__type">
                  {type.name}{" "}
                  {type.name.includes("Премиум") && (selectedProgram.program?.name.includes("Детокс") || selectedProgram.program?.name.includes("Общее")) ? (
                    <Recommend isPrem={selectedProgram.program?.name.includes("Детокс")} />
                  ) : null}
                </div>
              </label>
            </li>
          ))}
        </ul>
      );
    },
    [selectedProgram, toggleType]
  );

  // Рендеринг длительностей
  const renderLengths = useCallback(
    (progId) => {
      const types = programs.find((program) => program.id === progId)?.types || [];
      const lengths = types.find((type) => type.id === selectedProgram.program_type?.id)?.lengths || [];
      return lengths.length > 0 ? (
        <ul className="lengths__list">
          {lengths.map((len) => (
            <li key={len}>
              <label>
                <input
                  type="checkbox"
                  onChange={() => toggleLength(len)}
                  checked={selectedProgram?.program_length === len}
                />
                <div>{len}</div>
              </label>
            </li>
          ))}
        </ul>
      ) : null;
    },
    [selectedProgram, toggleLength]
  );

  if (!programs?.length) return null;

  return (
    <ul className="program_list">
      {programs.map((program) => (
        <li key={program.id}>
          <label>
            <input
              type="checkbox"
              onChange={() => toggleProgram(program.id)}
              checked={selectedProgram?.program?.id === program.id}
            />
            <div>{program.name}</div>
          </label>
          {selectedProgram?.program?.id === program.id && (
            <>
              {program.types?.length > 1 && renderTypes(program.id)}
              {renderLengths(program.id)}
            </>
          )}
        </li>
      ))}
    </ul>
  );
});

export default ProgramList;